export default "/assets/vegetarian.svg";